import { BODY_POSES } from '../gardener/body';
import { SET_ART, type SetArt } from '../gardener/sets';
import { type BodyPose, Flair, type FlairSpec } from './engine';

export * from './engine';

const SETS: Record<string, SetArt> = SET_ART;

/**
 * The flair of what a gardener wears (ADR-0160): its head's (by its hat), its outfit's and its gun skin's, each keyed
 * like its set; empty for a gardener in nothing mythic. A piece worn alone brings its own: the skull burns over overalls.
 */
export function flairSpecs(hat: string, outfit: string, gun: string): FlairSpec[] {
  const of = (key: string, piece: 'head' | 'outfit' | 'gun') =>
    Object.hasOwn(SETS, key) ? (SETS[key]?.flair?.[piece] ?? null) : null;
  return [of(hat, 'head'), of(outfit, 'outfit'), of(gun, 'gun')].filter((s): s is FlairSpec => s !== null);
}

/** A gardener's flair in `hat`, `outfit` and `gun`, or null when nothing it wears has any. */
export function flairFor(hat: string, outfit: string, gun: string, seed = 1): Flair | null {
  const specs = flairSpecs(hat, outfit, gun);
  return specs.length ? new Flair(specs, seed) : null;
}

/** How the body stands on `frame` of `anim` (`BODY_POSES`): what flair rides. */
export const bodyPose = (anim: 'idle' | 'run', frame: number): BodyPose => {
  const poses = BODY_POSES[anim];
  return poses[((frame % poses.length) + poses.length) % poses.length] as BodyPose;
};
